import { create } from 'zustand';
import { Mandate, InteractionFilter } from './types';

/**
 * Store for managing the state of the Evaluation & Engagement Desk.
 */

interface EngagementState {
  // Selection
  selectedStudentId: string | null;
  selectedTaskId: string | null;
  selectedCourseId: string | null;
  activeModuleId: string | null;
  activeModuleTitle: string | null;

  // Filtering
  filter: InteractionFilter;

  // UI State
  isWorkspaceOpen: boolean;
  activeMandates: Mandate[];

  // Actions
  selectStudent: (studentId: string | null, courseId?: string | null, moduleId?: string | null, moduleTitle?: string | null) => void;
  selectTask: (taskId: string | null) => void;
  setModule: (moduleId: string | null) => void;
  setMandates: (mandates: Mandate[]) => void;
  setFilter: (filter: InteractionFilter) => void;
  closeWorkspace: () => void;
}

export const useEngagementStore = create<EngagementState>((set) => ({
  selectedStudentId: null,
  selectedTaskId: null,
  selectedCourseId: null,
  activeModuleId: null,
  activeModuleTitle: null,
  filter: {},
  isWorkspaceOpen: false,
  activeMandates: [],

  selectStudent: (studentId, courseId = null, moduleId = null, moduleTitle = null) => set({
    selectedStudentId: studentId,
    selectedCourseId: courseId,
    activeModuleId: moduleId,
    activeModuleTitle: moduleTitle,
  }),

  selectTask: (taskId) => set({
    selectedTaskId: taskId,
    isWorkspaceOpen: !!taskId,
  }),

  setModule: (moduleId) => set({
    activeModuleId: moduleId,
  }),

  setMandates: (mandates) => set({
    activeMandates: mandates,
  }),

  setFilter: (filter) => set((state) => ({
    filter: { ...state.filter, ...filter },
  })),

  closeWorkspace: () => set({
    selectedStudentId: null,
    selectedTaskId: null,
    activeModuleTitle: null,
    isWorkspaceOpen: false,
  }),
}));

export default useEngagementStore;
